import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { CleaningSharingSection } from './components/CleaningSharingSection';
import { SavingsCalculator } from './components/SavingsCalculator';
import { MaintenanceSection } from './components/MaintenanceSection';
import { IntegrationsSection } from './components/IntegrationsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col w-full bg-page-bg" data-id="element-0">
      <Navbar data-id="element-1" />

      <main className="flex-grow flex flex-col w-full" data-id="element-2">
        <HeroSection data-id="element-3" />

        <NeighborhoodMap data-id="element-4" />

        <CleaningSharingSection data-id="element-5" />

        <MaintenanceSection data-id="element-6" />

        <SavingsCalculator data-id="element-7" />

        <IntegrationsSection data-id="element-8" />

        <CtaSection data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}